var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuideEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / Note_Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50015 3H5.40015C4.56007 3 4.13972 3 3.81885 3.16349C3.5366 3.3073 3.3073 3.5366 3.16349 3.81885C3 4.13972 3 4.56007 3 5.40015V12.6001C3 13.4402 3 13.86 3.16349 14.1809C3.3073 14.4632 3.5366 14.6929 3.81885 14.8367C4.1394 15 4.55925 15 5.39768 15H12.6023C13.4408 15 13.86 15 14.1805 14.8367C14.4628 14.6929 14.6929 14.4629 14.8367 14.1807C15 13.8601 15 13.4408 15 12.6023V10.5M12 3.75L7.5 8.25V10.5H9.75L14.25 6M12 3.75L14.25 1.5L16.5 3.75L14.25 6M12 3.75L14.25 6",
    stroke: "#5E42E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuideEdit);
export default __webpack_public_path__ + "static/media/ic_guide_edit.e06871dcb3e8db069a64d4641bc4ba6d.svg";
export { ForwardRef as ReactComponent };